
function compareOrdering (a, b) {
  return a.ordering - b.ordering
}

/* Calculates changes to ordering
 * existingItems: array of {ordering: x, anything}
 * newItems: array of {anything}
 * targetPosition: 1-based target position in overall set of items
 * -> object comprising pair of arrays of {ordering: x, anything} named existingItems and newItems
 */
function newOrdering (existingItems, newItems, targetPosition) {
  if (typeof existingItems !== 'object' || !Array.isArray(existingItems) ||
      typeof newItems !== 'object' || !Array.isArray(newItems) ||
      typeof targetPosition !== 'number') {
    console.warn('Unexpected parameters ' + typeof existingItems + ' ' + typeof newItems + ' ' + typeof targetPosition)
  }
  if (targetPosition < 0 || targetPosition > existingItems.length + newItems.length) {
    console.warn('Unexpected target position ' + targetPosition)
    return []
  }

  /*
  const r = new go.Set()
  const iteratorExisting = existingItems.iterator
  while (iteratorExisting.next()) {
    r.add(iteratorExisting.value)
  }
  const iteratorNew = newItems.iterator
  while (iteratorNew.next()) {
    r.add(iteratorNew.value)
  }
  */

  const orderedExistingItems = existingItems.sort(compareOrdering)
  const targetIndex = targetPosition - 1
  const reorderedExistingItems = []
  let i = 0
  for (; i < orderedExistingItems.length; i++) {
    const x = orderedExistingItems[i]
    let y = {...x}
    y.ordering = i + 1 + (i < targetIndex ? 0 : newItems.length)
    reorderedExistingItems.push(y)
  }
  const orderedNewItems = []
  for (let i = 0; i < newItems.length; i++) {
    const x = newItems[i]
    let y = {...x}
    y.ordering = targetPosition + i
    orderedNewItems.push(y)
  }
  return {existingItems: reorderedExistingItems, newItems: orderedNewItems}
}

function orderByOrdering (pa, pb) {
  if (pa && 'data' in pa && pb && 'data' in pb) {
    var da = pa.data
    var db = pb.data
    if ('ordering' in da && 'ordering' in db) {
      const a = parseInt(da.ordering)
      const b = parseInt(db.ordering)
      if (a < b) return -1
      if (a > b) return 1
    } else {
      console.warn('missing ordering property')
    }
  }
  return 0
}

export { newOrdering, orderByOrdering }



// WEBPACK FOOTER //
// ./src/utils/ordering.js